import React, { Component } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";

/* REDUX */
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ConsumidoresActions from "../../store/ducks/consumidores";

/*Styles*/
import { Container, Content, Panel } from "./tables-style.js";

/*Layout*/
import { Table, Button, Form, Row, Col, InputGroup } from "react-bootstrap";

/*Components*/
import Is from "../../components/Is";
import Header from "../../components/Header";
import TopBar from "../../components/TopBar";
import Loader from "../../components/Loader";

class Consumidores extends Component {
  state = {
    filter: ""
  };

  componentDidMount() {
    const { id } = this.props.match.params;
    const { getConsumidores } = this.props;
    getConsumidores(id);
  }

  /* Pega o texto dos inputs */
  handleInputChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  /* Filta os dados */
  handleFilter = () => {
    const { id } = this.props.match.params;
    const { filter } = this.state;
    const { getConsumidores } = this.props;
    getConsumidores(id, 1, filter);
  };

  /* Paginação */
  handlePageClick = data => {
    const { id } = this.props.match.params;
    const { getConsumidores } = this.props;
    const { filter } = this.state;
    let selected = data.selected;
    selected = selected + 1;
    getConsumidores(id, selected, filter);
  };

  handleDelete = (id, client_id) => {
    const { deleteConsumidor } = this.props;
    deleteConsumidor(id, client_id);
  };

  render() {
    const { id } = this.props.match.params;
    const { consumidores } = this.props;
    return (
      <Container>
        {!consumidores.loaded && <Loader />}
        <Header />
        <Content>
          <TopBar title="Consumidores" />
          <Panel>
            <div className="container_action">
              <h1>Lista de consumidores</h1>
              <div>
                <Is checkRole="administrator">
                  <Link
                    className="btn btn-outline-primary margin-r-10"
                    to={`/consumidores/${id}/cadastro`}
                  >
                    <i className="fa fa-plus" /> &nbsp; Novo consumidor
                  </Link>
                </Is>
                <Link className="btn btn-success" to="/">
                  <i className="fa fa fa-arrow-left" /> &nbsp; Voltar
                </Link>
              </div>
            </div>

            <div className="panel-container">
              <p className="filter-form-text">Filtros:</p>
              <Row>
                <Col xs={12} md={12} lg={4}>
                  <InputGroup className="mb-3">
                    <Form.Control
                      type="text"
                      placeholder="Nome"
                      name="filter"
                      onChange={this.handleInputChange}
                    />
                    <Button
                      variant="outline-primary"
                      onClick={() => {
                        this.handleFilter();
                      }}
                      className="filterButton no-margin"
                    >
                      <i className="fa fa-search" />
                    </Button>
                  </InputGroup>
                </Col>
              </Row>
              <br />
              <Table responsive hover>
                <thead>
                  <tr>
                    <th className="textCenter">Sigla</th>
                    <th className="textCenter">Nome Fantasia</th>
                    <th className="textCenter">Editar</th>
                    <Is checkRole="administrator">
                      <th className="textCenter">Remover</th>
                    </Is>
                  </tr>
                </thead>
                <tbody>
                  {consumidores.loaded && !consumidores.data.length ? (
                    <tr>
                      <td colSpan="5">Nenhum consumidor encontrado</td>
                    </tr>
                  ) : (
                    consumidores.data.map(consumidor => (
                      <tr key={consumidor.IdConsumidor}>
                        <td className="textCenter">{consumidor.SiglaNum}</td>
                        <td className="textCenter">
                          {consumidor.NomeFantasia}
                        </td>
                        <td className="textCenter">
                          <Link
                            className="btn btn-outline-primary"
                            to={`/consumidores/${consumidor.IdCliente}/editar/${
                              consumidor.IdConsumidor
                            }`}
                          >
                            <i className="fa fa-edit" />
                          </Link>
                        </td>
                        <Is checkRole="administrator">
                          <td className="textCenter">
                            <Button
                              variant="outline-danger"
                              onClick={() => {
                                this.handleDelete(
                                  consumidor.IdConsumidor,
                                  consumidor.IdCliente
                                );
                              }}
                            >
                              <i className="fa fa-warning" />
                            </Button>
                          </td>
                        </Is>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
              <div className="alignCenter">
                <ReactPaginate
                  previousLabel={"<"}
                  nextLabel={">"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={consumidores.consumidoresInfo.lastPage}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={2}
                  onPageChange={this.handlePageClick}
                  disableInitialCallback={true}
                  containerClassName={"pagination"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"}
                />
              </div>
            </div>
          </Panel>
        </Content>
      </Container>
    );
  }
}
const mapStateToProps = state => ({
  consumidores: state.consumidores
});
const mapDispatchToProps = dispatch =>
  bindActionCreators({ ...ConsumidoresActions }, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Consumidores);
